import React, { useMemo } from 'react';
import Select from 'components/global/CUK/AsyncSelect/Select';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { OptionMultiCount } from 'components/global/CUK/AsyncSelect/components/Option';

import { OPERATION_COUNT_STATUS } from '../../operations-gql/queries';

const StatusSelect = ({ onChange, values =[] }) => {
  const { data } = useQuery(OPERATION_COUNT_STATUS);
  const { t } = useTranslation();
  const choices = [
    {
      label: t('auth.account_status.activated'),
      value: 'active',
      id: 1,
    },
    {
      label: t('auth.account_status.pending'),
      value: 'unconfirmed',
      id: 2,
    },
    {
      label: t('auth.account_status.disabled'),
      value: 'deactivated',
      id: 3,
    },
  ];
  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={choices}
      mainField="label"
      placeholder={t('auth.admin.select_placeholder')}
      onChange={(values) => onChange(values.map(({ value }) => value))}
      components={{
        Option: (props) => {
          const count = useMemo(() => {
            return data
              ? data.states.find((state) => state.key === props.data.value)
                  ?.count
              : 0;
          }, [data]);
          return (
            <OptionMultiCount {...props} value={props.data} count={count} />
          );
        }
      }}
      value={choices.filter(
        (choice) => values.findIndex((value) => choice.value === value) > -1,
      )}
    />
  );
};

export default StatusSelect
